import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isNil } from 'ramda';
import { UnifiedPrivacy } from '@prezi/presentation-service-client';
import { Dumb } from '../';
import { unifiedPrivacyActions } from '../../../store/actions/unifiedPrivacyActions';
import { isPermissionAllowed } from '../../../api/userPermissions';
const mapPermission = (setPermissions, unifiedPrivacy, isPublished, isReusable) => {
  const publishedKey = isPublished ? 'published' : 'unPublished';
  const reusableKey = isReusable ? 'reusable' : 'copyrighted';
  const mapping = {
    [UnifiedPrivacy.unified_privacy.OPEN]: {
      published: {
        reusable: setPermissions.open.published.reusable,
        copyrighted: setPermissions.open.published.copyrighted
      },
      unPublished: {
        reusable: setPermissions.open.unPublished.reusable,
        copyrighted: setPermissions.open.unPublished.copyrighted
      }
    },
    [UnifiedPrivacy.unified_privacy.CLOSED]: {
      published: {
        reusable: setPermissions.closed.published,
        copyrighted: setPermissions.closed.published
      },
      unPublished: {
        reusable: setPermissions.closed.unPublished.reusable,
        copyrighted: setPermissions.closed.unPublished.copyrighted
      }
    }
  };
  return mapping[unifiedPrivacy][publishedKey][reusableKey];
};
const ToggleReusable = () => {
  const dispatch = useDispatch();
  const [unifiedPrivacyData, unifiedPrivacySetPermissions] = useSelector(state => {
    var _state$userPermission;
    return [state.unifiedPrivacy.value, (_state$userPermission = state.userPermissions.value) === null || _state$userPermission === void 0 ? void 0 : _state$userPermission.unifiedPrivacy.set];
  });
  if (isNil(unifiedPrivacyData)) {
    return null;
  }
  const calculateDisabledState = () => {
    if (unifiedPrivacySetPermissions !== undefined) {
      if (!unifiedPrivacyData.is_owner) {
        return {
          disabled: true,
          reason: 'shared'
        };
      } else {
        if (!isPermissionAllowed(mapPermission(unifiedPrivacySetPermissions, unifiedPrivacyData.unified_privacy, unifiedPrivacyData.is_published, unifiedPrivacyData.is_reusable))) {
          return {
            disabled: true,
            reason: 'notAllowed'
          };
        }
      }
    }
    return {
      disabled: false
    };
  };
  return isNil(unifiedPrivacyData) ? null : React.createElement(Dumb.ToggleReusable, {
    state: calculateDisabledState(),
    checked: unifiedPrivacyData.is_reusable,
    handleOnChange: newValue => dispatch(unifiedPrivacyActions.setReusable(newValue))
  });
};
export default ToggleReusable;